import Editor from './dist/react-simple-code-editor';

export default Editor;
